import { VehiclesCanHistoryMessages, TranslationVehiclesCanHistoryMessages } from "../interfaces";

export const messages: TranslationVehiclesCanHistoryMessages = {
  [VehiclesCanHistoryMessages.title]: "Vehicle history - CAN",
  [VehiclesCanHistoryMessages.generalHistory]: "General history",
  [VehiclesCanHistoryMessages.historyByEquipment]: "History by Vehicle",
  [VehiclesCanHistoryMessages.equipment]: "Vehicle",
  [VehiclesCanHistoryMessages.travels]: "Travels Qty",
  [VehiclesCanHistoryMessages.engineRuntime]: "Engine Runtime (h:mm)",
  [VehiclesCanHistoryMessages.idleEngineHours]: "Idle Hours (h:mm)",
  [VehiclesCanHistoryMessages.kmTraveled]: "Total Distance Traveled (km)",
  [VehiclesCanHistoryMessages.speedingAlerts]: "Speed Exceeded Alert",
  [VehiclesCanHistoryMessages.licensePlate]: "License plate",
  [VehiclesCanHistoryMessages.fuelConsumption]: "Total Fuel Consumption (L)",
  [VehiclesCanHistoryMessages.idleFuelConsumption]: "Idle Fuel Consumption (L)",
  [VehiclesCanHistoryMessages.avgFuelConsumption]: "Avg Moving Consumption (km/L)",
  [VehiclesCanHistoryMessages.litersPerHour]: "Consumption per Engine Hour (L/h)",
  [VehiclesCanHistoryMessages.litersPerM3]: "Consumption per m³ (L/m³)",
  [VehiclesCanHistoryMessages.litersPerTravel]: "Consumption per Travel (L)",
  [VehiclesCanHistoryMessages.idleLitersPerHour]: "Idle Consumption Rate (L/h)",
  [VehiclesCanHistoryMessages.fuelingAlerts]: "Fuel Variation Alert (+)",
  [VehiclesCanHistoryMessages.suddenDropAlerts]: "Fuel Variation Alert (-)",
  [VehiclesCanHistoryMessages.highTemperatureAlerts]: "High Temperature Alert",
  [VehiclesCanHistoryMessages.vehicleType]: "Vehicle Type",
  [VehiclesCanHistoryMessages.vehicles]: "Vehicle Qty"
};
